"use client";

import React from "react";

import type { IconProps } from "@/types";

import icons from "@/assets/svg";

import * as S from "./styles";

const Icon: React.FC<IconProps> = ({ name, className }) => {
  return <S.IconComponent className={className}>{icons[name]}</S.IconComponent>;
};

export default Icon;
